import React, { Suspense } from "react";
import { lazyComReload } from "utils/lazyComReload";
import { Switch, Route } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { REGISTRO_PREFIX_PATH } from "configs/AppConfig";

export const RegistroViews = () => {
	return (
		<Suspense fallback={<Loading cover="page" />}>
			<Switch>
				<Route
					path={`${REGISTRO_PREFIX_PATH}/sucesso`}
					component={lazyComReload(() =>
						import(`../registro-views/registro/RegistroSucesso`),
					)}
				/>

				<Route
					path={`${REGISTRO_PREFIX_PATH}/darkside-sucesso`}
					component={lazyComReload(() =>
						import(
							`../registro-views/registro/RegistroDarksideSucesso`
						),
					)}
				/>

				<Route
					path={`${REGISTRO_PREFIX_PATH}/:codigoIndicacao`}
					component={lazyComReload(() =>
						import(`../registro-views/registro/RegistroForm`),
					)}
				/>

				<Route
					path={`${REGISTRO_PREFIX_PATH}`}
					component={lazyComReload(() =>
						import(`../registro-views/registro/RegistroForm`),
					)}
				/>
			</Switch>
		</Suspense>
	);
};

export default RegistroViews;
